<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :style="{ height: '450px' }"
    :close-on-click-overlay="false"
    @click-overlay="clickClose"
    @open="onOpen"
    @close="onClose">
    <div class="contain">
      <div class="title">请输入支付密码</div>
      <!-- 密码输入框 -->
      <van-password-input
        class="pwdInput"
        :value="value"
        :focused="showKeyboard"
        :length="6"
        @focus="showKeyboard = true">
      </van-password-input>
      <div class="forgetPwd" @click="clickForgetPwd">忘记密码</div>
      <van-number-keyboard
        v-model="value"
        :maxlength="6"
        :show="true"
        @blur="showKeyboard = false"></van-number-keyboard>
    </div>
  </van-popup>
</template>

<script>
import { NumberKeyboard, PasswordInput, Popup } from "vant"
export default {
  name: "PasswordInput",
  components: {
    [Popup.name]: Popup,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    password: ""
  },
  data() {
    return {
      value: "",
      showKeyboard: true
    }
  },
  watch: {
    value(value) {
      if (value.length === 6) {
        //请求接口，判断密码是否正确
        this.$emit("update:password", value)
        this.$emit("startPay")
        this.clickClose()
      }
    }
  },
  methods: {
    clickClose() {
      this.$emit("update:visible", false)
    },
    onOpen() {
      this.showKeyboard = true
      this.value = ""
    },
    onClose() {
      this.clickClose()
    },
    clickForgetPwd() {
      this.$router.push({ name: "settingPwd" })
    }
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  background-color: rgb(239, 240, 242);
}
.contain {
  .title {
    color: rgb(70, 72, 75);
    font-size: 15px;
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
  .van-password-input__security li {
    background-color: rgb(239, 240, 242);
    border: 1px solid rgb(208, 211, 213);
  }
  .forgetPwd {
    color: rgb(209, 53, 57);
    padding: 10px 20px;
    margin-left: calc(100% - 100px);
    width: 60px;
    text-align: right;
  }
}
</style>